var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgVDecline = function (_a) {
    var title = _a.title, titleId = _a.titleId, desc = _a.desc, descId = _a.descId, props = __rest(_a, ["title", "titleId", "desc", "descId"]);
    return (_jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId }, props, { children: [desc ? _jsx("desc", __assign({ id: descId }, { children: desc })) : null, title ? _jsx("title", __assign({ id: titleId }, { children: title })) : null, _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.31 3.723a1 1 0 0 1 1.38-1.446c1.918 1.83 3.24 3.33 4.119 4.551 1.478-.747 3.493-1.105 5.164-.21 1.28.687 1.943 1.723 2.351 2.865.276.771.458 1.676.636 2.561.067.333.133.663.204.982.471 2.133 1.24 4.5 3.836 6.791V16a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1h-6a1 1 0 1 1 0-2h3.328c-2.742-2.568-3.61-5.252-4.117-7.542a60.135 60.135 0 0 1-.244-1.174c-.165-.818-.302-1.501-.526-2.128-.295-.825-.693-1.388-1.414-1.775-.864-.463-2.11-.339-3.17.158.243.503.396.957.464 1.366.141.844-.074 1.723-.875 2.148-.69.367-1.466.188-1.983-.14-.452-.288-.816-.67-1.013-1.156a2.16 2.16 0 0 1-.053-1.447c.145-.485.434-.924.794-1.305-.784-1.09-2.015-2.5-3.882-4.282Zm5.302 6.533H7.6h.012Zm-.251.19s.002-.004.003-.014c-.003.008-.004.014-.003.014Z", fill: "currentColor" })] })));
};
export default SvgVDecline;
